/** Identity of the console. Imported by vite.config.ts, so no DOM or Node APIs. */
export const APP = {
  name: 'Quản lý Ca đoàn',
  themeColor: '#1f5fd6',
  backgroundColor: '#f5f6f8',
  storagePrefix: 'cadoan_console_v1',
} as const

export const storageKey = (name: string) => `${APP.storagePrefix}_${name}`

/** Empty in development (Vite proxies /api); the Worker URL in production. */
export const API_BASE: string = import.meta.env?.VITE_API_BASE ?? ''
